import { Component, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

export interface CommentSheetData {
  title: string;
  comment?: string;
}

@Component({
  selector: 'app-comment-sheet',
  templateUrl: './comment-sheet.component.html',
  styleUrls: ['./comment-sheet.component.scss'],
  standalone: false
})
export class CommentSheetComponent {

  public comment: string;

  constructor(
    public sheetRef: MatBottomSheetRef<CommentSheetComponent, string>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: CommentSheetData,
  ) {
    this.comment = data.comment ?? '';
  }

  submit(): void {
    this.sheetRef.dismiss(this.comment);
  }

  close(): void {
    this.sheetRef.dismiss();
  }
}
